<template>
	<div class="custom-bottom w100 bg-black f-light-gray text-center pt15 pb15 flex-start-center mt30" :style="$util.getClientType() ? 'min-height: 90px; min-width: 900px;' : 'min-height: 90px; width: 100%'">
		<div style="border-right: solid 1px var(--gray);" class="pr30 pl15">
			<p>
				版权所有 2023 成都卢卡狮集团<a href="https://beian.miit.gov.cn/" target="_blank" class="ml10">{{icp}}</a>
			</p>
			<p class="flex-start align-center">
				<img src="../../static/img/record.png" />
				<a :href="recordUrl" target="_blank" class="ml10">{{recordName}}</a>
			</p>
			<p>
				<!-- <a href="javascript:void(0)">川公网安备 51019002001789号</a> -->
			</p>
		</div>
		<div class="pl30 pr30">
			<p>
				<i class="el-icon-phone pr10"></i>咨询热线：028-85251337/028-85371815
			</p>
			<p>
				<i class="el-icon-postcard pr10"></i>联系地址：成都火车南站西路481号
			</p>
		</div>
		<!-- 开启底部安全区适配 -->
		<van-number-keyboard safe-area-inset-bottom />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				icp: '蜀ICP备2023001373号-2',
				recordName: '川公网安备 51010702003308号',
				recordUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010702003308'
			}
		},
		created() {
			var _this = this;
			if (location.origin.includes('cdlucas.net')) {
				_this.icp = '蜀ICP备2023001373号-1'
				_this.recordName = '川公网安备 51010702003307号'
				_this.recordUrl = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010702003307'
			}
		}
	}
</script>

<style>
	.custom-bottom {}

	.custom-bottom a {
		color: #999999 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/custom-bottom.vue